export default __webpack_public_path__ + "static/Graphik-Medium-Web-d437c8d94859a7d9bd2d735ef16baa56.eot";